export default __webpack_public_path__ + "static/media/shift planning icon.43a3dc01.svg";